@if (displayListForm) {
  <div class="form-container" [formGroup]="displayListForm">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Name </label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="displayListForm"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="displayListForm" id="name"
            [formControlName]="'name'" placeholder="Enter name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <clickatell-form-validation [controlName]="'description'"
            [form]="displayListForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="displayListForm" id="description"
              [formControlName]="'description'" placeholder="Enter description"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Pattern </label>
              </div>
              <clickatell-form-validation [controlName]="'pattern'"
              [form]="displayListForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="displayListForm" id="pattern"
                [formControlName]="'pattern'" placeholder="Enter pattern"/>
              </div>
              <div class="control-div toggle-field">
                <div class="label-left-block">
                  <label class="control-label"> List Numbers </label>
                </div>
                <div class="toggle-btn">
                  <mat-slide-toggle [color]="'primary'" class="control-toggle"
                    [formControlName]="'listNumbers'">
                  </mat-slide-toggle>
                </div>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Custom Index </label>
                </div>
                <input class="control-input" activeForm [activeForm]="displayListForm" id="indexPattern"
                  [formControlName]="'indexPattern'" placeholder="Enter custom index"/>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Filter By </label>
                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'filterBy'"></app-cms>
                  </div>
                  <div class="control-container">
                    <input class="control-input control-container-variable" [formControlName]="'filterByKey'"
                      placeholder="Pattern"/>
                      <input class="control-input control-container-variable" [formControlName]="'filterByValue'"
                        placeholder="Value"/>
                      </div>
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> Exclude </label>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'exclude'"></app-cms>
                      </div>
                      <div class="control-container">
                        <input class="control-input control-container-variable" [formControlName]="'excludeKey'"
                          placeholder="Pattern"/>
                          <input class="control-input control-container-variable" [formControlName]="'excludeValue'"
                            placeholder="Value"/>
                          </div>
                        </div>
                      </ng-container>
                    </clickatell-expansion-panel>
                    <clickatell-expansion-panel>
                      <ng-container header>
                        <mat-panel-title>
                          Logic
                        </mat-panel-title>
                      </ng-container>
                      <ng-container body>
                        <div class="control-result">
                          <div class="control-result-header">
                            Yes
                          </div>
                          <div class="control-result-container">
                            <div class="control-div">
                              <label class="control-label">
                                <span class="pont-to">Point To</span>
                                <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                              </label>
                              @if (nodeFlowDetails) {
                                <next-selector [canEditFlows]="canEdit.canEditFlows"
                                  [selectorType]="'both'"
                                  [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                  [flows]="nodeFlowDetails.flows"
                                  [name]="'yes'"
                                  [form]="displayListForm"
                                  [stepId]="nodeFlowDetails.stepId">
                                </next-selector>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="control-result">
                          <div class="control-result-header">
                            No
                          </div>
                          <div class="control-result-container">
                            <div class="control-div">
                              <label class="control-label">
                                <span class="pont-to">Point To</span>
                                <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                              </label>
                              @if (nodeFlowDetails) {
                                <next-selector [canEditFlows]="canEdit.canEditFlows"
                                  [selectorType]="'both'"
                                  [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                  [flows]="nodeFlowDetails.flows"
                                  [name]="'no'"
                                  [form]="displayListForm"
                                  [stepId]="nodeFlowDetails.stepId">
                                </next-selector>
                              }
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </clickatell-expansion-panel>
                  </div>
                }